//  hzero-boot 全局配置
import { overWriteConfig } from 'hzero-boot';
import React from 'react';
import { isArray } from 'lodash';
import { configure } from 'choerodon-ui';
// import { TableQueryBarType } from 'choerodon-ui/pro/lib/table/enum';
import _HzeroNotification from "hzero-ui/lib/notification";
import _C7nNotification from "choerodon-ui/lib/notification";
import { ButtonColor, FuncType } from "choerodon-ui/pro/lib/button/enum";
// import { getConfig } from 'choerodon-ui';
// import { AxiosStatic } from 'axios';
// import { extendsEnvConfig } from 'utils/iocUtils';
import request from 'utils/request';
import { getCurrentOrganizationId, getResponse } from 'utils/utils';
import { HZERO_PLATFORM } from 'utils/config';
import TableQueryBarStyles from './components/QueryBarC7N';

interface ILookupRecord {
  value: string;
  [key: string]: any;
}

let lookupData: ILookupRecord | undefined;
let PHONE_PATTERN;
// 查询值集信息
async function queryCode(params = {}) {
  return request(`${HZERO_PLATFORM}/v1/${getCurrentOrganizationId()}/lovs/data`, {
    query: params,
  });
}

function splitLength(str: string): string {
  const start = str.indexOf('[');
  if (str === '') {
    return '';
  }
  if (start === -1) {
    return `^${str}\\d{${11 - str.length}}$`;
  } else {
    return `^${str}\\d{${11 - start - 1}}$`;
  }
}

// 手机号前缀规则维护在值集 HPFM.PHONE_NO_SEGMENT
async function getLoopupValue() {
  const res = await queryCode({ lovCode: 'HPFM.PHONE_NO_SEGMENT' });
  if (getResponse(res)) {
    lookupData = res;
  }
};

function generatPhoneRegExp() {

  if (!isArray(lookupData)) {
    return '';
  }

  if(PHONE_PATTERN) {
    return PHONE_PATTERN;
  }

  const pattern = (lookupData || []).reduce<string[]>((str: string[], currentNO: ILookupRecord) => {
    if (currentNO.value.startsWith('/')) {
      // 替换正则表达式首尾 / 和 \
      const patternBody = currentNO.value.replace(/^\/|\/$/g, "").replace(/\\/g, "\\");
      str.push(patternBody);
      return str;
    }
    const segment: string[] = currentNO.value.split('|');
    const parttenStr: string[] = [];
    segment.forEach(number => {
      parttenStr.push(splitLength(number));
    });

    return str.concat(parttenStr.join('|'));
  }, []);

  PHONE_PATTERN = new RegExp(pattern.join('|'));
  return PHONE_PATTERN;
}

// 获取参数
function getUrlParam (name) {
  const reg = new RegExp(`(^|&)${ name }=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) return unescape(r[2]); return null; // 返回参数值
};

overWriteConfig({
  initC7nUiConfig: () => {
    require('utils/c7nUiConfig');
    configure({
      // queryBar: TableQueryBarType.professionalBar,
      queryBar: (props) => React.createElement(TableQueryBarStyles, props),
      tableButtonProps: { color: ButtonColor.default, funcType: FuncType.raised },
    });
  },
  dvaAppInit: (app) => {
    const isExternalLink = getUrlParam('externalLink');
    if (isExternalLink === 'true') {
      sessionStorage.setItem('externalLink', 'true');
    } else {
      sessionStorage.removeItem('externalLink');
    }

    // extendsEnvConfig({
    //     TODO_API: '/htodo',
    // });

    // const axios: AxiosStatic = getConfig('axios');
    // axios.interceptors.request.use(
    //   (config) => {
    //     return {
    //       ...config,
    //       headers: {
    //         ...config?.headers,
    //         common: {
    //           // test: 'abcd',
    //           ...config?.headers?.common,
    //         },
    //       },
    //     };
    //   },
    //   (error) => {
    //     return Promise.reject(error);
    //   }
    // );
    // 飞搭配置
    app.use(require('hzero-front-hlod/lib/utils/dvaPluginForMicroFront').default(app));
    // setCard({ code: 'test', component: () => import('./TestCard') });
    // require('hzero-front-demo-common/src/customize/index.ts');
    require('./global.less');
    _HzeroNotification.config({
      duration: 30,
    });
    _C7nNotification.config({
      duration: 30,
    });
  },
  dvaRootRouter: () => require('./router.js').default,
  initPhone: getLoopupValue,
  phoneReg: generatPhoneRegExp,
});
